enum ActionTypes {
  GET_ALL_GAMES = '@excludedGames/GET_ALL_GAMES',
  GET_EXCLUDED_GAMES = '@excludedGames/GET_EXCLUDED_GAMES',
  SAVE_EXCLUDED_GAMES = '@excludedGames/SAVE_EXCLUDED_GAMES',
}

export default ActionTypes
